<template>
    <div v-if="config" class="w-full">
        <SettingCard
            v-bind="binds"
            @updateProfile="updateProfile()"
            :hideMoreVert="true"
            v-model:active="managementAuthorization"
            :hidePrevious="true"
        >
            <!-- :hideMoreVert="true"
            :hidePrevious="true" -->
            <v-row no-gutters class="d-flex justify-center">
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col cols="9" class="d-flex align-center"> Fournisseurs </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateConfiguration()"
                                v-model="managementAuthorizations.supplier"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="9" class="d-flex align-center"> Clients </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateConfiguration()"
                                v-model="managementAuthorizations.client"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="9" class="d-flex align-center"> Note de frais </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateConfiguration()"
                                v-model="managementAuthorizations.expenseReport"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="9" class="d-flex align-center"> Salaires </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateConfiguration()"
                                v-model="managementAuthorizations.salary"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="9" class="d-flex align-center"> Comptes courants </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateProfile()"
                                v-model="managementAuthorizations.operatingAccount"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </SettingCard>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

// const BobbeeImg = require("../../../assets/img/bobbee_mini.png")

@Component({
    components: {
        SettingCard,
    },
    emits: ["updateProfile"],
})
export class SettingManagementAuthorizations extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: null }) companyId!: string;
    @Prop({ default: null }) profileId!: string;
    @Prop({ default: false }) forMyCompany: boolean;

    managementAuthorization_: boolean = true;

    managementAuthorizations_ = {
        supplier: true,
        client: true,
        expenseReport: true,
        salary: true,
        operatingAccount: true,
        selectedClient: true,
    };

    binds = {
        title: "Gestion des encours",
        partnerName: "bobbee",
        text: "Paramétrez la gestion de vos encours.",
        // logo: BobbeeImg
    };

    get managementAuthorization() {
        if (this.config) {
            return this.config.managementAuthorization;
        }
        return this.managementAuthorization_;
    }

    set managementAuthorization(value) {
        if (this.config) {
            this.config.managementAuthorization = value;
        }
        this.managementAuthorization_ = value;
    }

    get managementAuthorizations() {
        if (this.config?.managementAuthorizations) {
            return this.config.managementAuthorizations;
        }
        return this.managementAuthorizations_;
    }

    updateConfiguration() {
        if (!this.managementAuthorization) {
            this.managementAuthorization = true;
        }
        this.updateProfile();
    }

    updateProfile() {
        if (!this.managementAuthorization) {
            this.managementAuthorizations.supplier = false;
            this.managementAuthorizations.client = false;
            this.managementAuthorizations.expenseReport = false;
            this.managementAuthorizations.salary = false;
            this.managementAuthorizations.operatingAccount = false;
        }
        this.$emit("updateProfile");
    }

    validCategory = ["ALL", "OTHER"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL",
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }

    // beforeMount() {
    //     console.log("managementAuthorization",this.config.managementAuthorization)
    // }
}

export default toNative(SettingManagementAuthorizations);
</script>
